import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Row, Col } from 'react-bootstrap';
import PollContent from './PollContent';
import AddPoll from './AddPoll';

export default function PollPage({ agenda, item }) {
  // const [polls, setPolls] = useState([]); // State to store polls
  const [matchingPoll, setMatchingPoll] = useState(null);
  const params = useParams();
  const meetingId = params.meetingId;
  const url = process.env.REACT_APP_URL;
  const { user: authUser } = useSelector((state) => state.auth);

  console.log(meetingId);

  const getPolls = useCallback(async () => {
    try {
      const response = await fetch(`${url}/polls/${meetingId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        // setPolls(data); // Store all poll objects
        // Find poll with the same title as agendaEvent.title
        const found = data.find(
          poll => poll.title === item?.agendaEvent?.name
        );
        setMatchingPoll(found || null);
      } else {
        console.error('Failed to fetch polls:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching polls:', error);
    }
  }, [url, meetingId, item?.agendaEvent?.name]);

  useEffect(() => {
    getPolls();
  }, [getPolls]);

  return (
    <>
      <Row className='mb-3 mt-5'>
        <Col>
          {authUser?.user.acl === "Officer" && !matchingPoll &&
            <AddPoll agenda={agenda} item={item} meetingId={meetingId} getPolls={getPolls} />
          }
          {matchingPoll ? (
            <PollContent pollId={matchingPoll._id} getPolls={getPolls} />
          ) : (
            <p className='text-center'>The Poll for this Agenda Item was not yet created.</p>
          )}

          {/* {polls.length > 0 ? (
            polls.map((pollId) => (
              <PollContent key={pollId} pollId={pollId} getPolls={getPolls} />
            ))
          ) : (
            <p>The Poll for this Agenda Item was not yet created.</p>
          )} */}
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-3">
          <Button variant="primary" onClick={getPolls} className="w-100">
            Reload Poll <i className="bi bi-arrow-clockwise"></i>
          </Button>
        </Col>
      </Row>
    </>
  )


  // return (
  //   <>
  //     {matchingPoll ? (
  //       <Row className="mb-3 mt-3">
  //         <Col xs={12}>
  //           <h4>Poll: {matchingPoll.title}</h4>
  //           <ul>
  //             {matchingPoll.options.map((option, idx) => (
  //               <li key={idx}>
  //                 {option.firstName} {option.lastName} - Votes: {option.votes}
  //               </li>
  //             ))}
  //           </ul>

  //           <div>Status: {matchingPoll.status}</div>
  //         </Col>
  //       </Row>
  //     ) : (
  //       authUser?.user.acl === "Officer" ?
  //         <Button variant="primary">
  //           Create a Poll for "{item?.agendaEvent?.name}"
  //         </Button>
  //         : <div>No poll available for this agenda item.</div>
  //     )}
  //   </>
  // );
}